import { useEffect, useState } from "react";
import 'react-quill/dist/quill.snow.css';
import FormLayouts from "./Components/FormLayouts.jsx";
import { ToastContainer, toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TitleBox from "../../Components/TitleBox/TitleBox.jsx";
import { GetAllAssignedRequests, getPendingDonorRequests, publishDonorRequest } from "../../api/index.js";
import { Button, Col, ConfigProvider, Row, Space, Table, Tag, Typography } from "antd";

const AllAssignedRequests = () => {
    const [data, setData] = useState([])
    const [filtered_data, setFilteredData] = useState([]);
    const [currentData, setCurrentData] = useState({})
    const [btnLoad, setBtnLoad] = useState(false)

    useEffect(() => {
        getAllAssignedRequests()

    }, []);

    const getAllAssignedRequests = async () => {

        let out = await GetAllAssignedRequests()

        if (out.status === 200) {

            setData(out.data.out)
            setCurrentData(out.data.out[0])
        }

    }

    const columns = [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'id'
        // },
        {
            title: 'Subject',
            dataIndex: 'subject',
            key: 'subject',
        },
        {
            title: 'Measure',
            dataIndex: 'measure_name',
            key: 'measure_name',
        },
        {
            title: 'Purpose',
            dataIndex: 'scope',
            key: 'scope',
            render: (_, { scope }) => (
                <Tag color={scope == 0 ? "#c1760d" : "#326379"} key={scope} style={{ width: 120, display: 'flex', justifyContent: 'center' }} >
                    {
                        scope == 0 ? "ALL COUNTRIES"
                            : "AGENCIES"
                    }
                </Tag>
            ),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        // {
        //     title: 'Attachment',
        //     dataIndex: 'attachment',
        //     key: 'attachment',
        // },
        {
            title: 'Support Type',
            dataIndex: 'assistance',
            key: 'assistance',
            render: (_, { assistance }) => (
                <Tag color={assistance == 0 ? "#f50" : "#2a8c00"} key={assistance} style={{ width: 150, display: 'flex', justifyContent: 'center' }} >
                    {
                        assistance == 0 ? "TECH ASSISTANCE"
                            : "CAPACITY BUILDING"
                    }
                </Tag>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_, { status }) => (
                <Tag color={status == 0 ? "#008282" : "#9B0259"} key={status} style={{ width: 120, display: 'flex', justifyContent: 'center' }} >
                    {
                        status == 0 ? "PENDING"
                            : "PUBLISHED"
                    }
                </Tag>
            ),
        },
    ];



    return <>
        <div style={{ display: 'flex', justifyContent: 'space-between', height: '100vh', overflow: "hidden" }}>

            <FormLayouts
                title="All Assigned Donors"
                formCardColor="white"
                formSide={false}
                table={

                    <Table
                        columns={columns}
                        dataSource={data}
                        pagination={{
                            pageSize: 8,
                            total: filtered_data.length,
                        }}
                        onRow={(record, rowIndex) => {
                            return {
                                onClick: () => {
                                    setCurrentData(record)
                                },
                            };
                        }}


                    />
                }
            />
            <ToastContainer
                transition={Zoom}
                position="top-center"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
            />



        </div >
    </>

}

export default AllAssignedRequests;